import { createApp } from "vue";
import { store } from './store/store';
import CountryRegionTrails from "./CountryRegionTrails.vue";


if (document.querySelector('#country_and_region_trails')) {

  const app = createApp(CountryRegionTrails)
  app.use(store)
  app.mount("#country_and_region_trails")
}
